<template>
  <div class="boxbgcolor poslist">
    <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div class="form-group">
            <label for>优免名称:</label>
            <input
              v-model="search.name"
              class="form-control"
              type="text"
              placeholder
              size="12"
              v-noBlankSpace
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button @click="searchList" type="button" class="btn btn-primary" id="search_btn">查询</button>
            </span>
            <span class="add_btn">
              <button type="button" class="btn btn-default" @click="addOrEdit()">添加</button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->

            <!-- <span class="refresh_btn"><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          border
          height="100%"
          :data="tableListData"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column show-overflow-tooltip label="优免名称" prop="name"></el-table-column>
          <el-table-column show-overflow-tooltip label="优免类型" prop="discountsType">
            <template slot-scope="scope">{{scope.row.discountsType}}</template>
            <!-- <template slot-scope="scope">{{scope.row.discountsType|$_formatDiscountType}}</template> -->
          </el-table-column>
          <!-- <el-table-column  show-overflow-tooltip
					label="优免明细"
					prop=""
					>
          </el-table-column>-->
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit operate-button"
                type="button"
                @click="addOrEdit(scope.row.id,scope.row.name,scope.row.discountsType)"
              >修改</button>
              <button class="delete operate-button" @click="del(scope.row.id)" type="button">删除</button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- <Page :pageSize="search.pageSize"></Page> -->
    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>
    <!--新增或修改-->
    <el-dialog
      title="新增或修改优免"
      :visible.sync="dialogFormVisible"
      :lock-scroll="false"
      :close-on-click-modal="false"
      width="40%"
      @close="resetForm"
    >
      <el-form ref="addOrEditForm" label-width="100px" :rules="addOrEditRules" :model="formData">
        <!-- <el-form-item label="所属商家">
					<el-input></el-input>
        </el-form-item>-->
        <el-form-item label="优免名称" prop="name">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item class="pAndERule" label="优免规则" prop="discountsType">
          <el-radio-group v-model="formData.discountsType">
            <el-radio
              v-for="item in allDiscountRulesData"
              :label="item.value"
              :key="item.id"
            >{{item.labelDefault}}</el-radio>
            <!-- <el-radio :label="3">按时缴费(全免)</el-radio>
            <el-radio :label="6">优免金额</el-radio>
            <el-radio :label="9">优免时间</el-radio>-->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addOrEditTrue">确定</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

import {
  getDiscountRulesByUserShop,
  requestAllDiscountRules,
  operateDiscountRules,
} from "@/api/url";

import Page from "../../commons/parking/commons/page";

import AreaTree from "../../commons/parking/commons/areaTree";

import Refresh from "../../commons/parking/commons/refresh";

let that; //filters使用

export default {
  data() {
    return {
      moduleName: "shops",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      treeData: {
        mchidId: "",

        parkingId: "",
      },
      formData: {
        id: "",
        name: "",
        discountsType: "",
        ratio: "20",
      },
      dialogFormVisible: false,
      dialogRechargeVisible: false,
      allFbType: [],
      allDiscountRulesData: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        name: "",
        // carType:"",
        // plateType:"",
        // openMethod:"",
        // beginDate:'',
        // endDate:''
      },
      tableListData: [],
      allCarTypes: null,
      allPlateTypes: null,
      allOpenMethods: null,
      defaultProps: {
        children: "children",
        label: "label",
      },

      formLabelWidth: "100px",

      allImgUrl: [],
      imgUrl: "",
      addOrEditRules: {
        discountsType: [
          {
            required: true,
            message: "请选择优免类型",
            trigger: ["change"],
          },
        ],
        name: [{ required: true, message: "请填写优免名称", trigger: "blur" }],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.parkingId) {
        this.$message({
          type: "warning",
          message: "请选择停车场",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function (node, data) {
      this.search.name = "";
      if (node.type === "shops") {
        this.treeData.mchidId = node.id;
        this.treeData.parkingId = node.parentId;
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
        this.getAllDiscountRules();
      } else {
        this.treeData.mchidId = "";
        this.tableListData = [];
        //  this.$message({
        // 	message: '请选择商户！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function (curPage) {
      var _this = this;
      this.$get(getDiscountRulesByUserShop(), {
        shopsId: this.treeData.mchidId,
        name: this.search.name,
        // carType:this.search.carType,
        // plateType:this.search.plateType,
        // matchingMethod:this.search.openMethod,
        // parkingId:this.treeData.parkingId,
        // beginDate:this.search.beginDate==''?'':JSON.stringify(this.search.beginDate),
        // endDate:this.search.endDate==''?'':JSON.stringify(this.search.endDate),
        limit: this.search.pageSize,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        _this.tableListData = data.data.rows;
      });
    },
    getAllDiscountRules() {
      this.$get(requestAllDiscountRules()).then((data) => {
        if (data.status != 200) return;
        this.allDiscountRulesData = data.data.rows;
      });
    },
    searchList: function () {
      if (!this.treeData.mchidId) {
        this.$message({
          type: "warning",
          message: "请选择商户",
        });
        return;
      }
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    addOrEdit(id, name, discountsType) {
      var _this = this;

      if (id) {
        this.dialogFormVisible = true;
        // this.$postRequest(getOneShopUser(),{
        // 	id:id
        // }).then(data=>{
        // 	if(data.status!=200) return;
        // 	this.formData.mchid=data.data.mchid;
        // 	this.formData.name=data.data.name;
        // 	this.formData.password=data.data.password;
        // 	this.formData.address=data.data.address;
        // 	this.formData.id=data.data.id;
        // })
        this.formData.id = id;
        this.formData.name = name;
        // this.formData.discountsType=discountsType;
        for (let item of this.allDiscountRulesData) {
          if (
            discountsType == item.labelDefault ||
            discountsType == item.value
          ) {
            this.formData.discountsType = item.value;
            // console.log(this.formData.discountsType)
          }
        }
      } else {
        if (this.treeData.mchidId) {
          this.dialogFormVisible = true;
          this.formData.id = "";
          this.formData.discountsType = "";
          this.formData.name = "";
        } else {
          this.dialogFormVisible = false;
          this.$message({
            message: "请选择商户!",
            type: "warning",
          });
        }
      }
    },
    addOrEditTrue() {
      var _this = this;
      this.$refs.addOrEditForm.validate(function (valid) {
        if (valid) {
          _this.dialogFormVisible = false;
          if (_this.formData.id) {
            _this
              .$putRequest(operateDiscountRules() + "/" + _this.formData.id, {
                id: _this.formData.id,
                name: _this.formData.name,
                shopsId: _this.treeData.mchidId,
                discountsType: _this.formData.discountsType,
                ratio: _this.formData.ratio,
                parkingId: _this.treeData.parkingId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          } else {
            _this
              .$postRequest(operateDiscountRules(), {
                name: _this.formData.name,
                shopsId: _this.treeData.mchidId,
                discountsType: _this.formData.discountsType,
                ratio: _this.formData.ratio,
                parkingId: _this.treeData.parkingId,
              })
              .then((data) => {
                if (data.status != 200) {
                  _this.$notify({
                    type: "warning",
                    title: "失败",
                    message: data.message,
                  });
                  return;
                }
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;
                _this.tableList(_this.search.pageNumber);
              });
          }
        } else {
        }
      });
    },

    del: function (id) {
      var _this = this;

      var index = _this.$layer.confirm(
        "您确定删除？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);

          _this
            .$deleteRequest(operateDiscountRules() + "/" + id + "?id=" + id)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功！",
              });
              _this.tableList(_this.pageObj.curIndex);
            });
        }
      );
    },
    resetForm() {
      this.$refs["addOrEditForm"].resetFields();
    },
    recharge() {
      this.dialogRechargeVisible = true;
    },
    rechargeTrue() {
      this.dialogRechargeVisible = false;
    },
  },
  // filters: {
  //   $_formatDiscountType(value) {
  //     if (this.allDiscountRulesData) {
  //       for (let item of this.allDiscountRulesData) {
  //         if (value == item.labelDefault || value == item.value) {
  //           return item.labelDefault;
  //         }
  //       }
  //       return "";
  //     }
  //   }
  // },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    Page,
    AreaTree,
    Refresh,
  },
  beforeCreate: function () {},
  created: function () {
    // this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.sameLine .el-form-item__content .el-input {
  display: inline-block;
  width: 70%;
}
.tip {
  color: red;
}
</style>
<style>
.pAndERule {
  display: flex;
  align-items: center;

  justify-content: flex-start;
}
.pAndERule .el-form-item__content {
  margin-left: 0 !important;
}
</style>